import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AuthenticationService } from '../../../../services/authentication.service';
import { Department } from '../../../parametrization/models/department';
import { VisitVehicle } from '../../models/visit-vehicle.entity';
import { DepartmentService } from '../../services/department.service';
import { VisitVehicleService } from '../../services/visit-vehicle.service';


/**
 * Dialog data
 */
 export interface DialogData {

  /**
   * Vehicle
   */
  visitVehicleId: string;
}

@Component({
  selector: 'app-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.scss']
})
export class EditComponent implements OnInit {

  /**
   * Is creating
   */
  isCreating: boolean;

  /**
   * Visit Vehicle form
   */
  visitVehicleForm: FormGroup;

  /**
   * Visit Vehicle
   */
  visitVehicle: VisitVehicle;

  /**
   * Departments array
   */
  departments: Department[];


  booleanValues: any = [{ id: true, description: 'Si'}, { id: false, description: 'No'}];

  constructor(public dialogRef: MatDialogRef<EditComponent>,
              @Inject(MAT_DIALOG_DATA) public data: DialogData,
              private visitVehicleService: VisitVehicleService,
              private departmentService: DepartmentService,
              private authService: AuthenticationService) {

  }
  /**
   * ngOnInit
   */
  ngOnInit(): void {
    this.visitVehicleForm = new FormGroup({
      initialEntryDate: new FormControl(null),
      endDateEntry: new FormControl(null),
      timePermitVisitHours: new FormControl(null),
      timePermitVisitMinutes: new FormControl(null),
      timePermitVisit: new FormControl(null),
      description: new FormControl(null, Validators.maxLength(32)),
      visitor: new FormControl(null, Validators.maxLength(32)),
      idCard: new FormControl(null, Validators.maxLength(16)),
      email: new FormControl(null, Validators.maxLength(64)),
      mobile: new FormControl(null, Validators.maxLength(16)),
      plate: new FormControl(null, Validators.maxLength(16)),
      departamentId: new FormControl(null),
      visited: new FormControl(null, Validators.maxLength(32)),
      authorized: new FormControl(null),
      permissionType: new FormControl(0)
    });
    // comentario para borrar
    this.visitVehicleForm.get('permissionType').valueChanges
      .subscribe(value => {
          if (value) {
            this.visitVehicleForm.get('endDateEntry').setValidators(Validators.required);
          } else {
            this.visitVehicleForm.get('endDateEntry').clearValidators();
          }
        }
      );

    if (this.data) {
      this.visitVehicleService.findFiltered( { visitId: this.data.visitVehicleId }).subscribe(
        (visitVehicle: any) => {
          if (visitVehicle.length > 0) {
            this.visitVehicle = visitVehicle[0];
            this.isCreating = false;
            for (const i in this.visitVehicleForm.controls) {
              if (this.visitVehicleForm.controls.hasOwnProperty(i)) {
                this.visitVehicleForm.controls[i].setValue(this.visitVehicle[i]);
              }
            }
            this.visitVehicleForm.controls.timePermitVisitHours.setValue(Math.floor(this.visitVehicle.timePermitVisit / 60));
            this.visitVehicleForm.controls.timePermitVisitMinutes.setValue(this.visitVehicle.timePermitVisit % 60);
          }
        });
    } else {
      this.visitVehicle = new VisitVehicle();
      this.isCreating = true;
      this.visitVehicleForm.controls.timePermitVisitHours.setValue(4);
      this.visitVehicleForm.controls.timePermitVisitMinutes.setValue(0);
      this.visitVehicleForm.controls.permissionType.setValue(0);
    }

    this.departmentService.list().subscribe((departments: Department[]) => {
      this.departments = departments;
    });

  }

  /**
   * Save visit vehicle form
   */

  // this.visitVehicle.userAuthorization = this.authService.currentUser.name;
  // this.visitVehicle.authorizationDate = new Date();

  save(): void {
    // tslint:disable-next-line:max-line-length
    this.visitVehicleForm.controls.timePermitVisit.setValue(parseInt(this.visitVehicleForm.controls.timePermitVisitHours.value) * 60 + parseInt(this.visitVehicleForm.controls.timePermitVisitMinutes.value));
    this.visitVehicleForm.removeControl('timePermitVisitHours');
    this.visitVehicleForm.removeControl('timePermitVisitMinutes');
    for (const i in this.visitVehicleForm.controls) {
      if (this.visitVehicleForm.controls.hasOwnProperty(i) && this.visitVehicleForm.controls[i].value !== null) {
        this.visitVehicle[i] = this.visitVehicleForm.controls[i].value;
      }
    }
    if (this.visitVehicle.authorized){
      this.visitVehicle.userAuthorization = this.authService.currentUser.name;
      this.visitVehicle.authorizationDate = new Date();
      // this.visitVehicle.authorizationDate = moment(new Date()).format('YYYY-MM-DD');
    }
    if (this.visitVehicle.endDateEntry){
      this.visitVehicle.timePermitVisit = null;
    }
    if (this.isCreating) {
      this.visitVehicle.situation = 1;

      // tslint:disable-next-line:max-line-length
      // this.visitVehicle.endDateEntry = moment((new Date(new Date(this.visitVehicle.initialEntryDate).getTime() + (1 * 24 * 60 * 60 * 1000)))).format('YYYY-MM-DD');

      // this.visitVehicle.endDateEntry = (new Date(new Date(this.visitVehicle.initialEntryDate).getTime() + (1 * 24 * 60 * 60 * 1000)));
      this.visitVehicleService.create(this.visitVehicle).subscribe(() => this.dialogRef.close({}));
    } else {
      this.visitVehicleService.update(this.visitVehicle).subscribe(() => this.dialogRef.close({}));
    }
  }

  /**
   * Close dialog
   */
  close(): void {
    this.dialogRef.close();
  }

  changeVisitType($event) {
    this.visitVehicleForm.controls.initialEntryDate.setValue(null);
    this.visitVehicleForm.controls.endDateEntry.setValue(null);
  }
}

